import React from 'react';
import createReactClass from 'create-react-class';
import Reflux from 'reflux';
import Modal from 'react-modal';
import map from 'lodash/map';

import dataStore from '../stores/data-store';

const appElement = document.querySelector('#bssp-app');

export default createReactClass({
	mixins: [Reflux.connect(dataStore, 'data')],

	render: function () {
		return (
			<>
				Legende{' '}
				<span className="visuallyhidden">
					{this.props.isOpen ? 'schließen' : 'öffnen'}
				</span>
				<Modal
					id="bssp-legend-modal"
					className="bssp-filter-selector-container"
					isOpen={this.props.isOpen}
					contentLabel="Legende"
					onRequestClose={() => {
						this.props.setIsOpen(false);
					}}
					appElement={appElement}
					style={{
						...Modal.defaultStyles,
						overlay: {
							...Modal.defaultStyles.overlay,
							zIndex: 1000,
							background: 'rgba(30, 30, 30, 0.6)',
							backdropFilter: 'blur(5px)',
							WebkitBackdropFilter: 'blur(5px)',
						},
						content: {},
					}}
				>
					<ul>
						{map(this.state.data.categoryFilters, (ids, name) => {
							const color =
								this.state.data.categoryColorMap[name] ??
								this.state.data.categoryColorMap.__default;

							return (
								<li className="bssp-legend-item" key={name}>
									<i
										className="bssp-legend-color"
										style={{
											background: color,
										}}
									/>
									{name}
								</li>
							);
						})}
					</ul>
				</Modal>
			</>
		);
	},
});
